import useFinanceHelper from './useFinanceHelper';

const FianceHelper: React.FunctionComponent = function () {
  const { text } = useFinanceHelper();
  if (!text) return null;
  return (
    <span className="text-10-14 text-neutral-700 text-center">{text}</span>
  );
};

export default FianceHelper;
